import { createSlice } from '@reduxjs/toolkit';
import { USERS_INITIAL_STATE } from './users.constants';
import {
  fetchUsersReducer,
  removeUserReducer,
  updateUserPrivilegesReducer,
  updateUserReducer,
} from './users.reducers';

// Create the users slice
const usersSlice = createSlice({
  name: 'users',
  initialState: USERS_INITIAL_STATE,
  reducers: {
    // Add any specific synchronous reducers here if needed
  },
  extraReducers: builder => {
    fetchUsersReducer(builder);
    removeUserReducer(builder);
    updateUserPrivilegesReducer(builder);
    updateUserReducer(builder);
  },
});

// Export the reducer
export default usersSlice.reducer;
